import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import FormEventHandlers from '../../../../../../libs/utility/formeventhandlers/FormEventHandlers';
import IRSLayoutRenderer from '../../../../../components/irsformview/IRSLayoutRenderer';
import Loadable from '../../../../../components/loadable/Loadable';
import { TOASTER_VARIANT } from '../../../../../components/toast/constants';
import AddPayer from '../../../../components/addpayernew/AddPayer';
import EditPayer from '../../../../components/addpayernew/editpayer/EditPayer';
import AddRecipient from '../../../../components/addrecipientnew/AddRecipient';
import EditRecipient from '../../../../components/addrecipientnew/editrecipient/EditRecipient';
import { addNotifications } from '../../../../toaster/ToasterPortalSlice';
import { CREATE_FORMS_LOADING_STATES, CREATE_FORM_STATES_MESSAGE_MAP } from '../../constants';
import { getPayer, getPayerOrRecipientForIRSView, getPayerList, getRecipient, getRecipientList, onDependentFieldChangeGetValues, saveForm } from '../../CreateFormSaga';
import { setIsIRSViewOn, setReloadFormsPreLoadedData, setTempFormFieldsList, setToCreateFormData } from '../../CreateFormSlice';
import { CHANGE_PAYER_LABEL_IN_FORMS } from '../../../formslisting/constants';
import Forms from '../../../../../../libs/utility/formsutility/Forms';
import { FORM_NAMES, QUERY_PARAMS } from '../../../constants';
import useTxSearchParams from '../../../../../../libs/txsearchparams/TxSearchParamsHook';

export default function IrsFormView({
    loadingState,
    recipientListLoadingState,
    tempFormFieldsList, 
    toCreateFormData, 
    onDependentFields, 
    formsPreLoadedData, 
    isIRSViewOn,
    userInteractionPopupWResponseObj,
    isStepperViewAvailable = false,
    formsInSeriesHistory,
    helpIconProps={},
}){
    const [isAddPayerModalOpen, setIsAddPayerModalOpen] = useState(false);
    const [isEditPayerModalOpen, setIsEditPayerModalOpen] = useState(false);
    const [payerIdForEdit, setPayerIdForEdit] = useState(null);
    const [isAddPayeeModalOpen, setIsAddPayeeModalOpen] = useState(false);
    const [isEditPayeeModalOpen, setIsEditPayeeModalOpen] = useState(false);
    const [payeeIdForEdit, setPayeeIdForEdit] = useState(null);
    const [isOpenIntermediaryPopup, setIsOpenIntermediaryPopup] = useState(false);
	const [intermediaryIdForEdit, setIntermediaryIdForEdit] = useState(null);

    const dispatch = useDispatch();
    const [queryParams,setQueryParams] = useTxSearchParams();

    const handleIRSFormSubmit = () => {
        const validationResult = FormEventHandlers.handleNextBtnClick("", tempFormFieldsList, isIRSViewOn, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), () => dispatch(addNotifications({ heading: "There are some errors in the fields.", message: "To save form, please resolve these errors" })));
        if(validationResult){
            let finalFormObject = tempFormFieldsList.reduce((obj, item) => {
                obj[item.Name] = item.inputValue || null;
                return obj;
            }, {});
            finalFormObject = {
                ...finalFormObject,
                FormName: toCreateFormData?.selectedForm?.FormId,
                PayerID: toCreateFormData?.selectedPayer?.PayerDetailId,
            }
            if(toCreateFormData?.FormRecordId){
                finalFormObject = {
                    ...finalFormObject,
                    FormRecordId: toCreateFormData?.FormRecordId,
                }
            }
            dispatch(saveForm({
                formName: toCreateFormData.selectedForm.FormId, 
                formData: {...finalFormObject},
                toCreateFormData: toCreateFormData,
                formsInSeriesHistory: formsInSeriesHistory,
            }));
        }
    }

    const handlePrevBtnClick = () => {
        let currFormPosition = formsInSeriesHistory.indexOf(toCreateFormData?.selectedForm?.FormId);
        const formsHistoryLength = formsInSeriesHistory.length;
        if(currFormPosition > 0){
            dispatch(setToCreateFormData({
                ...toCreateFormData,
                selectedForm: {
                    ...toCreateFormData?.selectedForm,
                    FormId: formsInSeriesHistory[currFormPosition-1],
                },
                isFormEditMode: true,
            }));
        }else if(formsHistoryLength > 0 && currFormPosition < 0){
            dispatch(setToCreateFormData({
                ...toCreateFormData,
                selectedForm: {
                    ...toCreateFormData?.selectedForm,
                    FormId: formsInSeriesHistory[formsHistoryLength-1],
                },
                isFormEditMode: true,
            }));
        }

    }

    const editPayerBtn = (payerId) => {
        setPayerIdForEdit(payerId);
        setIsEditPayerModalOpen(true);
    }

    const editPayeeBtn = (payeeId) => {
        setPayeeIdForEdit(payeeId);
        setIsEditPayeeModalOpen(true);
    }

    const dispatchErrorNotification = (displayMessage) => {
        dispatch(addNotifications({ heading: "Error", message: displayMessage }))
    }

    const handleGetRecipients = (toCreateFormData, editRecipientModeOn = false) => {
        if(toCreateFormData?.selectedPayer?.PayerDetailId && toCreateFormData?.selectedForm?.FormId){
            if(editRecipientModeOn){
                dispatch(getRecipient(toCreateFormData?.selectedRecipient?.RecipentDetailId));
            }
            dispatch(getRecipientList({
                PayerId: toCreateFormData.selectedPayer.PayerDetailId,
                FormName: toCreateFormData.selectedForm.FormId,
                Search: "",
                PerPage: null,
                LoadableLoadingState: {
                    loading: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING,
                    ready: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_READY,
                }
            }));    
        }
    }

    const addNewRow = (fieldName, allFields) => {
        dispatch(onDependentFieldChangeGetValues({
            formId: toCreateFormData.selectedForm.FormId,
            year: toCreateFormData.selectedYear,
            fieldId: fieldName.Name,
            allFields: allFields,
        }));
    }

    const handleAddEditIntermediaryAction = (intermediaryId = null) => {
        FormEventHandlers.handleAddEditIntermediaryAction(setIntermediaryIdForEdit, setIsOpenIntermediaryPopup, intermediaryId);
    }

    const handleAddNewPayer = (payer) => {
        dispatch(getPayerList())
        if(payer?.PayerDetailId) {
            dispatch(getPayer(payer.PayerDetailId)); 
        }
    }

    const handleDispatchNotification = (heading, message, variant = "DANGER") => {
        dispatch(addNotifications({
            heading: heading,
            message: message,
            variant: TOASTER_VARIANT[variant]
        }))
    }

    return <>
        <div>
            <Loadable 
                currentState={recipientListLoadingState.state} 
                loadingStates={[CREATE_FORMS_LOADING_STATES.RECIPIENT_PAGE_LOADING]} 
                messageMap={CREATE_FORM_STATES_MESSAGE_MAP}
                isNewLoadable={true}
                preserveChildMount={true}
            >
                <Loadable 
                    currentState={loadingState.state} 
                    loadingStates={[CREATE_FORMS_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING, CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING, CREATE_FORMS_LOADING_STATES.SAVING_FORM_LOADING]} 
                    messageMap={CREATE_FORM_STATES_MESSAGE_MAP}
                    isNewLoadable={true}
                    preserveChildMount={true}
                >
                    {
                        (tempFormFieldsList !== null) ? <IRSLayoutRenderer 
                            tempFormFieldsList={tempFormFieldsList} 
                            toCreateFormData={toCreateFormData} 
                            formsPreLoadedData={formsPreLoadedData} 
                            isIRSViewOn={isIRSViewOn}
                            isStepperViewAvailable={isStepperViewAvailable}
                            isSingleFormCreationModule={true}
                            userInteractionPopupWResponseObj={userInteractionPopupWResponseObj}
                            setIsIRSViewOnCb={(value) => dispatch(setIsIRSViewOn(value))}
                            handleIRSFormSubmitCb={handleIRSFormSubmit}
                            onChangeCb={(e, field) => FormEventHandlers.inputValueChange(e, field, tempFormFieldsList, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), toCreateFormData, onDependentFields, (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), true)}
                            onBlurCb={(e, inputValidationResult, field) => FormEventHandlers.handleOnBlur(e, field, tempFormFieldsList, inputValidationResult, toCreateFormData, onDependentFields, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)))}
                            dropdownOnSelectCb={(name, selectedOption, field) => FormEventHandlers.handleDropDownValueChange(name, selectedOption, tempFormFieldsList, toCreateFormData, onDependentFields, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), (selectedOption, updatedTempFieldsList) => FormEventHandlers.handleIRSViewDropDownSelect(field, selectedOption, updatedTempFieldsList, (payerOrRecipientId, callForEndpoint, updatedFieldsList) => dispatch(getPayerOrRecipientForIRSView({payerOrRecipientId: payerOrRecipientId, callForEndpoint: callForEndpoint, tempFormFieldsList: updatedFieldsList, toCreateFormData: toCreateFormData, field: field})), (selectedYear) => dispatch(setToCreateFormData(selectedYear))), true, (heading, message, variant) => handleDispatchNotification(heading, message, variant), true, (IssuerId) => dispatch(getRecipientList(
                                {
                                    PayerId: IssuerId,
                                    FormName: toCreateFormData.selectedForm.FormId,
                                    Search: "",
                                    PerPage: null,
                                    LoadableLoadingState: {
                                        loading: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING,
                                        ready: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_READY,
                                    }
                                }
                            )),
                            (data) => dispatch(setToCreateFormData(data)))}
                            dispatchNotificationCb={(heading, message, variant) => addNotifications({
                                heading: heading,
                                message: message,
                                variant: TOASTER_VARIANT[variant]
                            })}
                            backButtonProps={(formsInSeriesHistory.length > 0) ? {text: "Back",
                            clickCb: handlePrevBtnClick} : null }
                            nextButtonProps = {{
                                text: "Next",
                                clickCb: (loadingState.state === CREATE_FORMS_LOADING_STATES.SAVING_FORM_LOADING) ? () => {} : () => handleIRSFormSubmit(),
                            }}
                            customBtnsCbMap={{
                                "addPayerBtn": setIsAddPayerModalOpen,
                                "editPayerBtn": editPayerBtn,
                                "dispatchErrorNotification": dispatchErrorNotification,
                                "addPayeeBtn": setIsAddPayeeModalOpen,
                                "editPayeeBtn": editPayeeBtn,
                                "addNewRow": addNewRow, 
                                "handleAddEditIntermediaryAction": handleAddEditIntermediaryAction,
                            }}
                            showAddPayerBtn={Forms.isPayerSelectionAllowed(queryParams.get(QUERY_PARAMS.ALLOW_PAYER_RECIPIENT_SELECTION), toCreateFormData)}
                            helpIconProps={helpIconProps}
                        /> : null
                    }
                    {isAddPayerModalOpen && <AddPayer isPopup={true} isPopupOpen={isAddPayerModalOpen} onPopupCloseCb={() => setIsAddPayerModalOpen(false)} onFinalSubmitCb={ handleAddNewPayer } payerLabel={CHANGE_PAYER_LABEL_IN_FORMS[toCreateFormData?.selectedForm?.FormId] ?? "Payer"} />}
                    {isEditPayerModalOpen && <EditPayer payerID={payerIdForEdit} isPopup={true} isPopupOpen={isEditPayerModalOpen} onPopupCloseCb={() => setIsEditPayerModalOpen(false)} onFinalSubmitCb={() => handleAddNewPayer(toCreateFormData?.selectedPayer)} payerLabel={CHANGE_PAYER_LABEL_IN_FORMS[toCreateFormData?.selectedForm?.FormId] ?? "Payer"} />}
                    {isAddPayeeModalOpen && <AddRecipient isPopup={true} isPopupOpen={isAddPayeeModalOpen} onPopupCloseCb={() => setIsAddPayeeModalOpen(false)} onFinalSubmitCb={() => handleGetRecipients(toCreateFormData)} hidePayerSelectionStep={true} defaultSelectedPayer={toCreateFormData?.selectedPayer} is1042SForm={toCreateFormData?.selectedForm?.FormId === FORM_NAMES.FORM1042S} fromFormModule={true} />}
                    {isEditPayeeModalOpen && <EditRecipient recipientID={payeeIdForEdit} isPopup={true} isPopupOpen={isEditPayeeModalOpen} onPopupCloseCb={() => setIsEditPayeeModalOpen(false)} onFinalSubmitCb={() => handleGetRecipients(toCreateFormData, true)} is1042SForm={toCreateFormData?.selectedForm?.FormId === FORM_NAMES.FORM1042S} fromFormModule={true} />}
                    {isOpenIntermediaryPopup && <Intermediary intermediaryIdForEdit={intermediaryIdForEdit} isPopup={true} isPopupOpen={isOpenIntermediaryPopup} onPopupCloseCb={() => setIsOpenIntermediaryPopup(false)} onSubmitCb={() => dispatch(setReloadFormsPreLoadedData(true))} />}
                </Loadable>
            </Loadable>
        </div>
    </>
}